export default __webpack_public_path__ + "static/media/ellipse_bl.9b082d04.png";